import { ApplicationConfig, importProvidersFrom, provideZonelessChangeDetection, isDevMode } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ToastModule } from 'primeng/toast';

import { providePulsePrimeNG } from '@shared/ui';

import { provideHighcharts } from 'highcharts-angular';

import { CobrowseService } from '@shared/cobrowse';
import { HttpHelperService, IMenuBuilderService } from '@shared/services';

import { routes } from './walmart-us.routes';

import { iso8601ToJsonDateHttpInterceptor } from '@shared/utils';
import { MenuBuilderService, WalmartUserService } from '@walmart/services';
import { environment } from '../environments/environment';
import { ENVIRONMENT_CONFIG, TRAINING_PAGE_CONFIG } from '@shared/config';
import { getAuth0UiLocales } from '@shared/i18n';

import { provideAuth0, authHttpInterceptorFn } from '@auth0/auth0-angular';
import { AuthService, SessionManagementService } from '@shared/auth';
import { SharedPerm } from '@shared/constants';

const auth0UiLocales = getAuth0UiLocales();

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    { provide: ENVIRONMENT_CONFIG, useValue: environment },
    {
      provide: TRAINING_PAGE_CONFIG,
      useFactory: (authService: AuthService) => ({
        canManageTraining: () => authService.user().hasPermission(SharedPerm.IsLumatrak)
      }),
      deps: [AuthService]
    },
    provideZonelessChangeDetection(),
    provideHighcharts({
      instance: () => import('highcharts/esm/highcharts').then((m) => m.default),
      modules: () => {
        return [import('highcharts/esm/modules/accessibility'), import('highcharts/esm/modules/no-data-to-display')];
      }
    }),
    CobrowseService,
    ConfirmationService,
    DialogService,
    DecimalPipe,
    HttpHelperService,
    MessageService,
    { provide: IMenuBuilderService, useExisting: MenuBuilderService },
    provideHttpClient(withFetch(), withInterceptors([iso8601ToJsonDateHttpInterceptor(), authHttpInterceptorFn])),
    //TODO: Remove by version 23
    provideAnimationsAsync(),
    providePulsePrimeNG(),
    importProvidersFrom(ToastModule),
    provideAuth0({
      ...environment.auth0Config,
      authorizationParams: {
        ...environment.auth0Config.authorizationParams,
        ...(auth0UiLocales ? { ui_locales: auth0UiLocales } : {})
      },
      httpInterceptor: {
        allowedList: [
          {
            uri: `${environment.authApiUrl}/*`,
            tokenOptions: {
              authorizationParams: {
                audience: environment.auth0Config.authorizationParams.audience
              }
            }
          },
          {
            uri: `${environment.apiUrl}/*`,
            tokenOptions: {
              authorizationParams: {
                audience: environment.auth0Config.authorizationParams.audience
              }
            }
          }
        ]
      }
    }),
    WalmartUserService,
    AuthService,
    SessionManagementService,
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
